import React from 'react';

const CARDS = [
  { img: '/images/stage-1.webp?v=6', tag: 'Mind & body', title: 'Care that considers your hormones' },
  { img: '/images/stage-2.webp?v=6', tag: 'Active living', title: 'A plan built around your life' },
  { img: '/images/stage-3.webp?v=6', tag: 'Nutrition', title: 'Guidance on protein and nutrition' },
  { img: '/images/stage-4.webp?v=6', tag: 'Long-term wellness', title: 'Health beyond the scale' },
  { img: '/images/stage-5.webp?v=6', tag: 'Strength', title: 'Strength training as part of your plan' },
  { img: '/images/stage-6.webp?v=6', tag: 'Personalized dosing', title: 'Treatment paced for you' },
  { img: '/images/stage-7.webp?v=6', tag: 'Ongoing support', title: 'A care team in your corner' },
  { img: '/images/stage-8.webp?v=6', tag: 'Every stage', title: 'Care for midlife and beyond' },
];

const Card = ({ img, tag, title, i, hidden }) => (
  <figure
    aria-hidden={hidden || undefined}
    data-testid={hidden ? undefined : `stage-card-${i + 1}`}
    className={`relative shrink-0 mr-5 w-[220px] sm:w-[260px] lg:w-[290px] aspect-[3.6/4.7] overflow-hidden rounded-[18px] ${i % 2 ? 'rounded-tr-[95px]' : 'rounded-tl-[95px]'} shadow-[0_22px_45px_-30px_rgba(60,40,20,0.3)]`}
  >
    <img src={img} alt={hidden ? '' : title} loading="lazy" className="w-full h-full object-cover object-[center_30%]" />
    <figcaption className="absolute left-3 right-3 bottom-3 rounded-[20px] bg-[linear-gradient(135deg,rgba(255,255,255,0.72),rgba(255,248,240,0.45))] backdrop-blur-xl border border-white/70 px-5 py-4">
      <p className="text-[10.5px] uppercase tracking-[0.22em] text-[#a9772e]">{tag}</p>
      <p className="mt-2 text-[17px] sm:text-[19px] leading-[1.2] tracking-[-0.01em] text-[color:var(--alfa-ink)]">{title}</p>
    </figcaption>
  </figure>
);

export default function EveryStage() {
  return (
    <section data-testid="every-stage-section" className="bg-[color:var(--alfa-cream)]">
      <div data-testid="every-stage-frame" className="relative w-full overflow-hidden py-14 lg:py-0 lg:aspect-[16/9] lg:flex lg:flex-col lg:justify-center">
      <img src="/images/every-stage-bg.webp?v=2" alt="" aria-hidden="true" data-testid="every-stage-bg" className="absolute inset-0 w-full h-full object-cover" />
      <div aria-hidden="true" className="absolute inset-0 bg-[linear-gradient(180deg,rgba(251,247,241,0.15)_0%,transparent_40%)]" />
      <div className="relative text-center px-5 max-w-[860px] mx-auto">
        <p className="eyebrow">Real support. Personalized care.</p>
        <h2 className="mt-4 text-[34px] sm:text-[46px] lg:text-[54px] leading-[1.05] tracking-[-0.03em] text-[color:var(--alfa-ink)]">
          Personalized care,<br className="sm:hidden" /> at every stage.
        </h2>
        <p className="mt-4 text-[15px] sm:text-[16px] leading-[1.6] text-[color:var(--alfa-ink)]/80">
          GLP-1 care guided by licensed medical providers and built around your health history, goals, and lifestyle.
        </p>
      </div>

      <div className="relative stage-marquee mt-10 sm:mt-12" data-testid="stage-carousel">
        <div className="stage-track flex w-max">
          {[...CARDS, ...CARDS].map((c, i) => (
            <Card key={i} {...c} i={i % CARDS.length} hidden={i >= CARDS.length} />
          ))}
        </div>
      </div>
      </div>
    </section>
  );
}
